import React from 'react';
import { Button } from 'react-bootstrap';
import { RPM_ALERT_SEVERITIES } from '../../constants/other';
import {
    formatAlertTs,
    isAlertOverdue,
    overdueLabel,
    dueRelativeLabel,
} from '../../utils/rpmAlertQueueUtils';
export const RpmSeverityBadge = ({ severity }) => {
    if (!severity) {
        return null;
    }
    return (
        <span className={`rpm-severity-badge rpm-severity-badge--${severity.key.toLowerCase()}`}>
            {severity.label}
        </span>
    );
};

const resolveAlertSeverity = (alert) => {
    if (!alert) {
        return null;
    }
    if (alert.severity) {
        return RPM_ALERT_SEVERITIES.find((entry) => entry.key === alert.severity) || null;
    }
    return RPM_ALERT_SEVERITIES.find((entry) => entry.typeId == alert.urgent_todo_type_id) || null;
};

export const buildAlertMetaLine = (receivedTs, dueTs) => {
    const parts = [];
    if (receivedTs) {
        parts.push(`Received ${formatAlertTs(receivedTs)}`);
    }
    if (dueTs) {
        parts.push(`Due ${formatAlertTs(dueTs)}`);
    }
    if (dueTs) {
        if (isAlertOverdue(dueTs)) {
            parts.push(overdueLabel(dueTs));
        } else {
            const relative = dueRelativeLabel(dueTs);
            if (relative) {
                parts.push(relative);
            }
        }
    }
    return parts.join(' · ');
};

const RpmThresholdAlertListItem = ({
    alert,
    showCloseButton,
    onCloseAlert,
    closingTodoId,
}) => {
    const severity = resolveAlertSeverity(alert);
    const severityKey = severity ? severity.key.toLowerCase() : 'unknown';
    const receivedTs = alert.create_ts || alert.received_ts;
    const dueTs = alert.due_date_ts;
    const title = (alert.rpm_alert_type_name || '').trim();
    const thresholdLabel = (alert.rpm_threshold_name || '').trim();
    const description = (alert.description || '').trim();
    const showDescription = description && description !== title;
    const metaLine = buildAlertMetaLine(receivedTs, dueTs);
    const todoId = alert.todo_id || alert.id;
    const isClosing = closingTodoId != null && closingTodoId == todoId;

    const itemClassName = [
        'rpm-alert-column-list__item',
        `rpm-alert-column-list__item--${severityKey}`,
        showCloseButton ? 'rpm-alert-column-list__item--chart' : '',
    ].filter(Boolean).join(' ');

    return (
        <li className={itemClassName}>
            <div className="rpm-alert-column-list__badge">
                <RpmSeverityBadge severity={severity} />
            </div>
            <div className="rpm-alert-column-list__body">
                <div className="rpm-alert-column-list__headline">
                    {title &&
                        <span className="rpm-alert-strong">{title}</span>
                    }
                    {title && thresholdLabel &&
                        <span className="rpm-alert-muted"> · {thresholdLabel}</span>
                    }
                    {!title && thresholdLabel &&
                        <span className="rpm-alert-strong">{thresholdLabel}</span>
                    }
                </div>
                {showDescription &&
                    <div className="rpm-alert-column-list__description">{description}</div>
                }
                {metaLine &&
                    <div className="rpm-alert-muted rpm-alert-column-list__meta">{metaLine}</div>
                }
            </div>
            {showCloseButton && onCloseAlert &&
                <div className="rpm-chart-alert-close-col">
                    <Button
                        bsStyle="primary"
                        bsSize="small"
                        className="btn-primary rpm-chart-alert-close-btn"
                        disabled={isClosing}
                        onClick={() => onCloseAlert(todoId)}
                    >
                        {isClosing ? 'Closing…' : 'Close Alert'}
                    </Button>
                </div>
            }
        </li>
    );
};

export default RpmThresholdAlertListItem;
